import {createRouter, createWebHistory} from 'vue-router'
import Home from '../views/Home.vue'
import {guardRoute} from "../api";

const routes = [
    {
        path: '/',
        redirect: '/login',
        name: 'Home',
        component: Home
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        path: '/reports',
        beforeEnter: guardRoute,
        name: 'Reports',
        component: () => import(/* webpackChunkName: "reports" */ '../views/Reports.vue')
    },
    {
        path: '/report/:id?',
        beforeEnter: guardRoute,
        name: 'Report',
        component: () => import(/* webpackChunkName: "report" */ '../views/Report.vue')
    },
    {
        path: '/report-confirmation/:hash',
        name: 'ReportConfirmation',
        component: () => import('../views/ReportConfirmation.vue')
    },
    {
        path: '/emulsions',
        beforeEnter: guardRoute,
        name: 'States',
        component: () => import(/* webpackChunkName: "report" */ '../views/Emulsions.vue')
    },
    {
        path: '/emulsion/:id?',
        beforeEnter: guardRoute,
        name: 'State',
        component: () => import(/* webpackChunkName: "report" */ '../views/Emulsion.vue')
    },
    {
        path: '/emulsion-report-confirmation/:hash',
        name: 'EmulsionReportConfirmation',
        component: () => import('../views/EmulsionReportConfirmation.vue')
    },
    {
        path: '/tank-statement',
        beforeEnter: guardRoute,
        name: 'TankStatement',
        component: () => import( '../views/EmulsionTankStatement.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
